<template>
    <page-main tag="main" class="wrapper--page microsite--campus">
        <transition name="fade" mode="out-in">

            <Loader v-if="!hasSections" />

        </transition>
        <div v-show="isLoaded">
            <transition appear name="fade" mode="out-in">
                <Builder :sections="microsite.sections" />
            </transition>

            <MicrositePopover v-if="$route.path.includes('campus-microsite')" />

            <SlideLines />

            <PageCtas />
            <PageFooter />
        </div>
    </page-main>
</template>

<script>
import { gsap } from 'gsap'

import innerBackButton from '@/mixins/lib/innerBackButton'
import { focusOrderWatcher } from '@/mixins/focusOrder'

import Loader from '@/components/Loader'
import Builder from '../Builder/Builder.vue'
import SlideLines from '../Slide/SlideLines'
import PageFooter from '../PageFooter.vue'
import PageCtas from '../Discover/PageCtas'
import MicrositePopover from './MicrositePopover'

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
    name: 'CampusMicrosite',
    metaInfo() {
        return {
            title: this.microsite.title ? this.microsite.title : undefined
        }
    },

    components: {
        Loader,
        Builder,
        MicrositePopover,
        SlideLines,
        PageCtas,
        PageFooter,
    },

    mixins: [
        focusOrderWatcher,
    ],

    data: () => ({
        isLoaded: false,
        isBuilded: false,
    }),

    activated() {
        this.resolvePageTemplate()
    },

    beforeRouteUpdate(to, from, next) {
        gsap.set(document.body, {
            scrollTop: 0,
            onComplete: next
        })
    },

    computed: {
        microsite() {
            const path = this.$route.path.replace(/\/$/, '')
            const currentSlug = path.split('/')[2] || path.slice(1)
            const { campusPages } = this.$store.getters || []

            const page = campusPages.find((page) => {
                return page.slug === currentSlug
            })

            return {
                title: page && page.title ? page.title.rendered : '',
                sections: page && page.acf ? page.acf.flexible_content || [] : []
            }
        },
        hasSections() {
            return this.microsite.sections.length > 0
        },
        canRender() {
            return this.hasSections && this.isLoaded
        },
        backButton() {
            const { path } = this.$route

            const parentRoute = {
                path: 'campus-resources',
                label: 'Back to Campus Resources'
            }

            return innerBackButton(path, parentRoute)
        }
    },

    methods: {
        async resolvePageTemplate() {
            await this.$store.dispatch('fetchCampusPagesData')
            
            gsap.set(document.body, {
                scrollTop: 0,
                onComplete: async () => {
                    await sleep(200)
                    this.isLoaded = true
                }
            })
        },
        waitForBuilderDom() {
            return new Promise(resolve => {
                const check = () => {
                    const builder = this.$refs.builder && this.$refs.builder.$el

                    if (builder && builder.children.length > 0) {
                        resolve()
                    } else {
                        requestAnimationFrame(check)
                    }
                }

                requestAnimationFrame(check)
            })
        },
    }
}
</script>
